import { setWidget as setWidgetCore, setWidgetType as setWidgetTypeCore } from '@sitecore-search/core';
import { WidgetDataType } from '@sitecore-search/data';
import { previewSearchActionProps, previewSearchPropStateMapping, questionsActionProps, questionsPropStateMapping, recommendationActionProps, recommendationPropStateMapping, searchResultsActionProps, searchResultsPropStateMapping, } from '@sitecore-search/widgets';
import ContentBlockComponent from './widgets/contentBlock/index.js';
import ContentBlockSEOComponent from './widgets/contentBlock/seo.js';
const contentBlockConfig = {
    component: ContentBlockComponent,
    options: {
        state: {},
    },
};
export const setWidgetType = (type, mapping) => setWidgetTypeCore(type, mapping);
export function setWidget(rfkId, entityOrConfig, config) {
    if (typeof entityOrConfig === 'string') {
        return setWidgetCore(rfkId, entityOrConfig, config);
    }
    return setWidgetCore(rfkId, entityOrConfig);
}
export default () => {
    setWidgetType(WidgetDataType.CONTENT_BLOCK, contentBlockConfig);
    setWidgetType(WidgetDataType.HTML_BLOCK, contentBlockConfig);
    setWidgetType(WidgetDataType.BANNER, contentBlockConfig);
    setWidgetType(WidgetDataType.SEO, {
        ...contentBlockConfig,
        component: ContentBlockSEOComponent,
    });
    setWidgetType(WidgetDataType.PREVIEW_SEARCH, {
        options: {
            propStateMapping: previewSearchPropStateMapping,
            actionProps: previewSearchActionProps,
            state: {},
        },
    });
    setWidgetType(WidgetDataType.RECOMMENDATION, {
        options: {
            propStateMapping: recommendationPropStateMapping,
            actionProps: recommendationActionProps,
            state: {},
        },
    });
    setWidgetType(WidgetDataType.QUESTIONS, {
        options: {
            propStateMapping: questionsPropStateMapping,
            actionProps: questionsActionProps,
            state: {},
        },
    });
    setWidgetType(WidgetDataType.SEARCH_RESULTS, {
        options: {
            propStateMapping: searchResultsPropStateMapping,
            actionProps: searchResultsActionProps,
            state: {
                selectedFacets: {},
                page: 1,
            },
        },
    });
};
